module.exports = __webpack_public_path__ + "static/img/naoq-3.4998e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naoq-3.png
// module id = 257
// module chunks = 1